import { useEffect, useState } from "react";

import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useGetOrgUnitsData } from "../FSM/Beats_Patches/hooks/useBeat";
import { useDCRReport } from "./DCRReport/UseDCRReport";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import {
  DCRReportFunction,
  getPositionListForDailCallReport,
} from "./DCRReport/DCRReport_Repo";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { showToast } from "../../utils/toastUtils";
import { COLORS } from "../../constants/colors";

const DCRReport = () => {
  const { startPolling } = useExcelPolling();
  const [outletAPI_Search, setOutletAPI_Search] = useState("");
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });

  useEffect(() => {
    const handler = setTimeout(() => {
      setFilterData((prev: any) => ({
        ...prev,
        outlet_code: outletAPI_Search,
      }));
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [outletAPI_Search]);

  const [filterData, setFilterData] = useState({
    start_date: "",
    end_date: "",
    start: 1,
    length: 10,
    orgUnit: "",
    outlet_code: outletAPI_Search,
    action: "view",
    position: "",
  });

  const {
    data: DCRData,
    isLoading,
    isSuccess,
  } = useDCRReport({
    enable: true,
    param: {
      ...(filterData.start_date == ""
        ? {}
        : { start_date: filterData.start_date }),
      ...(filterData.end_date == "" ? {} : { end_date: filterData.end_date }),
      start: filterData.start,
      length: filterData.length,
      ...(filterData.orgUnit == "" ? {} : { orgUnit: filterData.orgUnit }),
      ...(filterData.outlet_code == ""
        ? {}
        : { outlet_code: filterData.outlet_code }),
      ...(filterData.position == "" ? {} : { position: filterData.position }),
      action: "view",
    },
  });

  const downloadExcelGet = async () => {
    const param = {
      ...(filterData.start_date == ""
        ? {}
        : { start_date: filterData.start_date }),
      ...(filterData.end_date == "" ? {} : { end_date: filterData.end_date }),
      start: filterData.start,
      length: filterData.length,
      ...(filterData.orgUnit == "" ? {} : { orgUnit: filterData.orgUnit }),
      ...(filterData.outlet_code == ""
        ? {}
        : { outlet_code: filterData.outlet_code }),
      ...(filterData.position == "" ? {} : { position: filterData.position }),
      action: "download",
    };
    try {
      setLoadingExcel(true);
      const response = await DCRReportFunction(param);
      const { success, fileDownloadId, intervalTime } =
        response.rowData.data || {};
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url: string) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFaled: (message: string) =>
            showToast.error(message || "onFalied error in DCR  report excel"),
          onExpired: (message: string) =>
            showToast.error(message || "onExpired error in  DCR report excel"),
          onDeleted: (message: string) =>
            showToast.error(message || "onDeleted error in DCR report excel "),
        });
      }
    } catch (error: any) {
      console.log("Error while downloading excel in DCR report");
    }
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };

  const handleInput = (key: any, value: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="DCR Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        SearchPlaceholder="Search by employee,code"
        Title="DCR Report"
        showSpinner={isLoading}
        dynamicHeightOnRowsPerPage={true}
        data={(!isLoading && isSuccess && DCRData?.formatedData) || []}
        columns={DCRReportColoumn}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <CustomDropdown
              placeholder="All"
              DropdownLabel="Select-Position"
              value={filterData.position}
              onChange={(id) => {
                setFilterData((prev: any) => ({
                  ...prev,
                  position: id,
                  start: 1,
                }));
              }}
              fetchData={async ({ page, limit, search }) => {
                const params = {
                  page: page,
                  limit: limit,
                  search: String(search),
                };
                const res = await getPositionListForDailCallReport(params);
                let formatedData = Array.isArray(res.rowData.data.Positions)
                  ? res.rowData.data.Positions.map((item: any) => ({
                      id: item.PositionId,
                      label: item.PositionName,
                    }))
                  : [];

                const rowData = (await res).rowData?.data.Positions;
                if (page === 1) {
                  formatedData = [{ id: "", label: "All" }, ...formatedData];
                }
                const hasMore = Object.keys(rowData).length == limit;
                return {
                  data: formatedData,
                  hasMore,
                };
              }}
              includeAllOption
            />

            <RoundedDropdown
              options={orgUnitsList?.data || []}
              onSelect={(e: any) => handleInput("orgUnit", e.id)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />
            {/* Month Dropdown */}
            <label style={{ color: "black", marginTop: "7px" }}>
              From Date
            </label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInput("start_date", e.target.value)
              }
            />

            <label style={{ color: "black", marginTop: "7px" }}>To Date</label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInput("end_date", e.target.value)
              }
            />

            <label style={{ color: "black", marginTop: "7px" }}>
              Outlet Code
            </label>
            <input
              type="txt"
              style={{
                padding: "6px 10px",
                border: "1px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
                width: "150px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setOutletAPI_Search(e.target.value)
              }
            />
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={DCRData?.rowData?.data?.recordsTotal || 0}
      />
    </div>
  );
};

export default DCRReport;

const DCRReportColoumn = [
  {
    name: "Division",
    selector: (row: { Division?: string }) => row.Division ?? "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Reporting Manager Position",
    selector: (row: { ReportingManagerPosition?: string | any }) =>
      row.ReportingManagerPosition == "" ? "-" : row.ReportingManagerPosition,
    sortable: true,
    width: "240px",
  },
  {
    name: "Reporting Manager",
    selector: (row: { ReportingManager?: string }) =>
      row.ReportingManager ?? "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Employee Position",
    selector: (row: { EmployeePosition?: string }) =>
      row.EmployeePosition ?? "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Employee Code",
    selector: (row: { EmployeeCode?: string }) => row.EmployeeCode ?? "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "Employee Name",
    selector: (row: { EmployeeName?: string }) => row.EmployeeName ?? "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Contact number",
    selector: (row: { ContactNumber?: string }) => row.ContactNumber ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Agenda",
    selector: (row: { Agenda?: string }) => row.Agenda ?? "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Planned",
    selector: (row: { Planned?: string }) => row.Planned ?? "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Customer Type",
    selector: (row: { CustomerType?: string }) => row.CustomerType ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Customer Code",
    selector: (row: { CustomerCode?: string }) => row.CustomerCode ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Customer Name",
    selector: (row: { CustomerName?: string }) => row.CustomerName ?? "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Customer Town",
    selector: (row: { CustomerTown?: string }) => row.CustomerTown ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Customer Patch",
    selector: (row: { CustomerPatch?: string }) => row.CustomerPatch ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Reporting Town",

    selector: (row: { ReportingTown?: string }) => row.ReportingTown ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Reporting Date",
    selector: (row: { ReportingDate?: string }) => row.ReportingDate ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Reporting Status",
    selector: (row: { ReportingStatus?: string }) => row.ReportingStatus ?? "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Joint Working - Field Member",
    selector: (row: { JointWorkingFieldMember?: string }) =>
      row.JointWorkingFieldMember ?? "-",
    sortable: true,
    width: "280px",
    wrap: true,
  },
  {
    name: "Joint Working - Field Member Position",
    selector: (row: { JointWorkingFieldMemberPosition?: string }) =>
      row.JointWorkingFieldMemberPosition ?? "-",
    sortable: true,
    width: "320px",
    wrap: true,
  },
  {
    name: "Joint Working - Managers",
    selector: (row: { JointWorkingManagers?: string }) =>
      row.JointWorkingManagers ?? "-",
    sortable: true,
    width: "250px",
    wrap: true,
  },
  {
    name: "NCA Remark",
    selector: (row: { NCARemark?: string }) => row.NCARemark ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Leave Taken",
    selector: (row: { LeaveTaken?: string }) => row.LeaveTaken ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "DCR Actual Coordinates",
    selector: (row: { DCRActualCoordinates?: string }) =>
      row.DCRActualCoordinates ?? "-",
    sortable: true,
    width: "280px",
  },
  {
    name: "Sync Date",
    selector: (row: { SyncDate?: string }) => row.SyncDate ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
];
